"use client";
// src/lib/sample-data/platform-plans.ts - Sample platform plan data
import { format } from 'date-fns';
import type { PlatformPlan } from '@/lib/types';

export const samplePlatformPlansData: PlatformPlan[] = [
  { 
    id: 'plan_starter', 
    name: 'Starter', 
    monthlyPrices: [ 
      { currencyCode: 'CHF', price: '29', priceDetails: '/ month' }, 
      { currencyCode: 'EUR', price: '29', priceDetails: '/ month' }, 
      { currencyCode: 'USD', price: '29', priceDetails: '/ month' }, 
      { currencyCode: 'GBP', price: '29', priceDetails: '/ month' }, 
    ],
    yearlyPrices: [ 
      { currencyCode: 'CHF', price: '290', priceDetails: '/ year (billed as 10 months)' }, 
      { currencyCode: 'EUR', price: '290', priceDetails: '/ year (billed as 10 months)' }, 
      { currencyCode: 'USD', price: '290', priceDetails: '/ year (billed as 10 months)' }, 
      { currencyCode: 'GBP', price: '290', priceDetails: '/ year (billed as 10 months)' }, 
    ], 
    yearlyDiscountMonths: 10, 
    description: 'Ideal for small clubs or individual coaches getting started.', 
    features: [ 
      { id: 'feat_starter_1', text: 'Up to 3 Courts', included: true, moduleId: 'max_spaces' }, 
      { id: 'feat_starter_2', text: 'User Self-Service Portal', included: true }, 
      { id: 'feat_starter_3', text: 'Online Payments (Standard Fees)', included: true }, 
      { id: 'billing_management_starter', text: 'Billing Management', included: false, moduleId: 'billing_management'}, 
      { id: 'sports_starter', text: 'Up to 1 Sport', included: true, moduleId: 'sports_limit'}, 
      { id: 'module_insights_starter', text: 'Insights & Analytics Module', included: false, moduleId: 'insights' }, 
    ], 
    maxClubs: 1, 
    maxUsersPerClub: 50, 
    maxSpaces: 3, 
    transactionFeePercent: 0, 
    startDate: format(new Date(2023, 0, 1), 'yyyy-MM-dd'), 
    endDate: undefined, 
    active: true,
    selfServiceEnabled: true, // Organizations can self-select this plan
  },
  { 
    id: 'plan_advanced', 
    name: 'Advanced', 
    monthlyPrices: [ 
      { currencyCode: 'CHF', price: '89', priceDetails: '/ month' }, 
      { currencyCode: 'EUR', price: '89', priceDetails: '/ month' }, 
      { currencyCode: 'USD', price: '89', priceDetails: '/ month' }, 
      { currencyCode: 'GBP', price: '89', priceDetails: '/ month' }, 
    ],
    yearlyPrices: [ 
      { currencyCode: 'CHF', price: '890', priceDetails: '/ year (billed as 10 months)' }, 
      { currencyCode: 'EUR', price: '890', priceDetails: '/ year (billed as 10 months)' }, 
      { currencyCode: 'USD', price: '890', priceDetails: '/ year (billed as 10 months)' }, 
      { currencyCode: 'GBP', price: '890', priceDetails: '/ year (billed as 10 months)' }, 
    ], 
    yearlyDiscountMonths: 10, 
    description: 'Perfect for growing clubs needing more features and capacity.', 
    features: [ 
      { id: 'feat_adv_1', text: 'Up to 8 Courts', included: true, moduleId: 'max_spaces' }, 
      { id: 'billing_management_advanced', text: 'Billing Management', included: true, moduleId: 'billing_management'}, 
      { id: 'feat_adv_2', text: 'Member Management', included: true }, 
      { id: 'feat_adv_3', text: 'Customizable Booking Rules', included: true }, 
      { id: 'feat_adv_4', text: 'Reduced Transaction Fees', included: true }, 
      { id: 'feat_adv_5', text: 'Waiting List Management', included: true }, 
      { id: 'sports_advanced', text: 'Up to 3 Sports', included: true, moduleId: 'sports_limit'}, 
      { id: 'module_insights_advanced', text: 'Insights & Analytics Module', included: true, moduleId: 'insights' }, 
    ], 
    maxClubs: 3, 
    maxUsersPerClub: 500, 
    maxSpaces: 8, 
    transactionFeePercent: 0, 
    startDate: format(new Date(2023, 0, 1), 'yyyy-MM-dd'), 
    endDate: undefined, 
    active: true,
    selfServiceEnabled: true, // Organizations can self-select this plan
  },
  { 
    id: 'plan_enterprise', 
    name: 'Enterprise', 
    monthlyPrices: [ 
      { currencyCode: 'CHF', price: 'Contact Us', priceDetails: '' }, 
      { currencyCode: 'EUR', price: 'Contact Us', priceDetails: '' }, 
      { currencyCode: 'USD', price: 'Contact Us', priceDetails: '' }, 
      { currencyCode: 'GBP', price: 'Contact Us', priceDetails: '' }, 
    ],
    yearlyPrices: [ 
      { currencyCode: 'CHF', price: 'Contact Us', priceDetails: '' }, 
      { currencyCode: 'EUR', price: 'Contact Us', priceDetails: '' }, 
      { currencyCode: 'USD', price: 'Contact Us', priceDetails: '' }, 
      { currencyCode: 'GBP', price: 'Contact Us', priceDetails: '' }, 
    ], 
    yearlyDiscountMonths: 10, 
    description: 'Tailored solutions for large organizations and chains.', 
    features: [ 
      { id: 'feat_ent_1', text: 'Unlimited Courts', included: true, moduleId: 'max_spaces' }, 
      { id: 'billing_management_enterprise', text: 'Billing Management', included: true, moduleId: 'billing_management'}, 
      { id: 'feat_ent_2', text: 'Member Management', included: true }, 
      { id: 'feat_ent_3', text: 'API Access & Integrations', included: true }, 
      { id: 'feat_ent_4', text: 'Dedicated Support Manager', included: true }, 
      { id: 'feat_ent_5', text: 'Custom Branding Options', included: true }, 
      { id: 'sports_enterprise', text: 'Unlimited Sports', included: true, moduleId: 'sports_limit'}, 
      { id: 'module_insights_enterprise', text: 'Insights & Analytics Module', included: true, moduleId: 'insights' }, 
    ], 
    maxClubs: 'unlimited', 
    maxUsersPerClub: 'unlimited', 
    maxSpaces: 'unlimited', 
    transactionFeePercent: 0, 
    startDate: format(new Date(2023, 0, 1), 'yyyy-MM-dd'), 
    endDate: undefined, 
    active: true,
    selfServiceEnabled: false, // Requires Super Admin to assign this plan
  },

];
